// New UI only (docs/ui_redesign/18-ux-review.md, R12): when Classic refuses to save a row it's editing (an error toast
// while a grid row is in edit mode), the row's empty fields are outlined and the first one gets focus. Typing a value
// clears its outline. Classic's checks and messages are unchanged.
export function markRefusedRow(doc = document) {
	const row = doc.querySelector('.MuiDataGrid-row--editing');
	if (!row) return 0;
	const empty = [...row.querySelectorAll('.MuiDataGrid-cell--editing input:not([type="checkbox"]):not([type="hidden"]), .MuiDataGrid-cell--editing select')]
		.filter(f => !f.disabled && !f.readOnly && String(f.value || '').trim() === '');
	empty.forEach(f => { f.setAttribute('aria-invalid', 'true'); const cell = f.closest('.MuiDataGrid-cell'); if (cell) cell.classList.add('apw2-invalid'); });
	if (empty[0]) empty[0].focus();
	return empty.length;
}

export function clearFixed(e) {
	const f = e.target;
	if (!f || !f.getAttribute || f.getAttribute('aria-invalid') !== 'true' || String(f.value || '').trim() === '') return;
	f.removeAttribute('aria-invalid');
	const cell = f.closest && f.closest('.MuiDataGrid-cell');
	if (cell) cell.classList.remove('apw2-invalid');
}
